
import ProductCTA from "@/components/ProductCTA";

const RecommendedProducts = () => {
  return (
    <div className="mt-16">
      <h2 className="text-2xl font-bold mb-6">You Might Also Like These Products</h2>
      <div className="space-y-6">
        <ProductCTA 
          variant="banner" 
          productName="Hey Humans Natural Deodorant" 
          productImage="/lovable-uploads/e3ece06c-b176-4067-a58f-bb4f1c09d65a.png"
          message="Try Hey Humans eco-friendly natural deodorant" 
          linkType="heyhumans" 
        />
        
        <ProductCTA 
          variant="inline" 
          productName="Breathe Naturals Deodorant Plus" 
          productImage="/lovable-uploads/a2ef7eb0-0c25-4d2e-885a-ecbd6e258b4a.png"
          message="Upgrade to Breathe Naturals Plus with extra strength protection" 
          linkType="breathe2" 
        />
        
        <ProductCTA 
          variant="banner" 
          productName="Breathe Naturals Advanced Formula" 
          productImage="/lovable-uploads/a2ef7eb0-0c25-4d2e-885a-ecbd6e258b4a.png"
          message="Experience our newest Advanced Formula deodorant" 
          linkType="breathe2" 
        />
      </div>
    </div>
  );
};

export default RecommendedProducts;
